import React, { useState, useEffect } from 'react';
import './header-overrides.css';
import { useTheme } from '../contexts/ThemeContext';

const Header = () => {
  const { isDarkMode } = useTheme();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // 🔹 controle da navbar (sumir/aparecer ao scroll)
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 10);

      if (window.scrollY > lastScrollY) {
        // descendo
        setShowNavbar(false);
      } else {
        // subindo
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastScrollY]);

  const toggleUserMenu = () => setIsUserMenuOpen(!isUserMenuOpen);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <>

      {/* Navigation */}
      <nav
        className={`navbar nav-top navbar-expand-lg d-flex px-3 px-sm-5 py-3 
          ${isScrolled ? (isDarkMode ? 'scrolled-dark' : 'scrolled-light') : ''}`}
        style={{
          opacity: 0.95,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          transition: 'transform 0.3s ease',
          transform: showNavbar ? 'translateY(0)' : 'translateY(-100%)',
        }}
      >
        <div className="order-1 col-4 col-sm flex-sm-grow-0 p-0 pr-sm-5">
          <a className="navbar-brand" href="/vitrine">
            <img
              alt="Logo"
              src="/logo-trading.png"
              style={{ width: '150px', height: 'auto', transform: 'scaleY(3.5)' }}
            />
          </a>
        </div>

        <div className="order-4 order-lg-2 col-12 col-lg px-0">
          <div className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`} id="top-menu">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <a className="nav-link" href="/vitrine">
                  Home
                </a>
              </li>
              <li className="nav-item nav-item-5163">
                <a className="nav-link" href="https://xxbroker.com" target="_blank" rel="noopener noreferrer">
                  A Melhor Corretora de Opções Binárias
                </a>
              </li>
              <li className="nav-item nav-item-5164">
                <a className="nav-link" href="https://t.me/trendingbrazil" target="_blank" rel="noopener noreferrer">
                  🔴 Sala de Sinais
                </a>
              </li>
              <li className="nav-item nav-item-5159">
                <a className="nav-link" href="https://www.instagram.com/xxbroker_official" target="_blank" rel="noopener noreferrer">
                  Siga nossa Conta no Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="order-2 order-sm-3 col col-lg-2 d-flex justify-content-end p-0 px-lg-1">
          <div className="navbar-right account-nav">

            <div className="dropdown ml-3">
              <button
                className="user-menu icon-wrapper dropdown-toggle"
                onClick={toggleUserMenu}
                aria-expanded={isUserMenuOpen}
              >
                <div className="avatar">
                  <img src="/vitrine_assets/image" alt="User Avatar"/>
                </div>
                <svg className="icon icon-angle-down"><use xlinkHref="#icon-angle-down"></use></svg>
              </button>
              <ul className={`dropdown-menu dropdown-menu-right ${isUserMenuOpen ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="/logout" onClick={(e) => { e.preventDefault(); if (window.onAppLogout) window.onAppLogout(); }}>Logout</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="order-3 col flex-grow-0 d-flex justify-content-end d-lg-none p-0">
          <button
            className="navbar-toggler"
            onClick={toggleMobileMenu}
            type="button"
            aria-expanded={isMobileMenuOpen}
          >
            <svg className="icon icon-menu"><use xlinkHref="#icon-menu"></use></svg>
          </button>
        </div>
      </nav>
    </>
  );
};

export default Header;